






















import Vue from "vue"
export default Vue.extend({
  name: "submenu-rudc",

  props:{
    isvisible: Boolean,
    evtclick: {},
  },

  created(){
    console.log("evtclick",(this as any).evtclick)
  },

  data: () => ({
    x:0,
    y:0,
    items: [
      { title: 'Detail', evt:"detail" },
      //{ title: 'Clone', evt:"clone" },
      //{ title: 'Update', evt:"update" },
      //{ title: 'Delete', evt:"delete"},
    ],
  }),

  computed:{
    is_visible:{
      get(): boolean {
        return (this as any).isvisible
      },
      set(v: any){
        (this as any).$emit("evtclose",v)
      }
    }
  },

  methods:{
    clickhandler(fncname){
      this.$emit("evtselected",fncname)
    },
  },

})
